import axios from 'axios'
import store from '@/store/store'

const api = axios.create({
  baseURL: process.env.VUE_APP_API,
})

api.interceptors.request.use(
  config => {
    const token = localStorage.getItem('accessToken')
    if (token) {
      config.headers['X-AUTH-TOKEN'] = token
    }

    const url = config.url.split('/')

    if (url[url.length - 1] === 'login') {
      delete config.headers['X-AUTH-TOKEN']
    }

    return config
  },
  error => Promise.reject(error)
)

let isAlreadyFetchingAccessToken = false
let subscribers = []

function onAccessTokenFetched(access_token) {
  subscribers = subscribers.filter(callback => callback(access_token))
}

function addSubscriber(callback) {
  subscribers.push(callback)
}

api.interceptors.response.use(
  function(response) {
    return response
  },
  function(error) {
    const {
      config,
      response: { status },
    } = error
    const originalRequest = config

    if (status === 401) {
      if (!isAlreadyFetchingAccessToken) {
        isAlreadyFetchingAccessToken = true
        store.dispatch('refresh').then(response => {
          const access_token = response.data.auth.tokens.access
          isAlreadyFetchingAccessToken = false
          onAccessTokenFetched(access_token)
        })
      }

      const retryOriginalRequest = new Promise(resolve => {
        addSubscriber(access_token => {
          originalRequest.headers['X-AUTH-TOKEN'] = access_token
          resolve(axios(originalRequest))
        })
      })
      return retryOriginalRequest
    }
    return Promise.reject(error)
  }
)

export default api
